import { render, staticRenderFns } from "./NavbarGlobal.vue?vue&type=template&id=c4aaf5aa&scoped=true&"
import script from "./NavbarGlobal.vue?vue&type=script&scoped=true&lang=js&"
export * from "./NavbarGlobal.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./NavbarGlobal.vue?vue&type=style&index=0&id=c4aaf5aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aaf5aa",
  null
  
)

export default component.exports